<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
	<div class="page-header_write" v-if="!noWrite">
		<div class="container flex">
			<a href="index.html"><img src="../assets/images/logo_blue1.png" alt="" height="38"/></a>
			<div class="items flex">
				<div v-for="(item, index) in menuArr" :key="index">
					<div v-if="!item.isArrow" :class="{ 'item-menu': 1, 'item-active': tabIndex == item.id }" @click="pageSet(item)">
						<div>{{ item.name }}</div>
					</div>
					<el-popover v-else placement="bottom" width="210" trigger="hover" :visible-arrow="false" popper-class="header-pop">
						<div class="menu-box">
							<template v-if="item.id == 1 && prodectArr.length != 0">
								<div :class="{'menu-item':1,active:currentProduct == item.id}"  v-for="(item, index) in prodectArr" :key="index" @click="handleClickProdect(item)">{{ item.productName }}</div>
							</template>
							<template v-if="item.id == 4 && planArr.length != 0">
								<div :class="{'menu-item':1,active:currentPlan == item.id}" v-for="(item, index) in planArr" :key="index" @click="handleClickPlan(item)">{{ item.schemeName }}</div>
							</template>
						</div>
						<div slot="reference">
							<div :class="{ 'item-menu': 1, 'item-active': tabIndex == item.id }" @click="pageSet(item)">
								<div>{{ item.name }}</div>
								<i style="margin-left: 4px;" v-if="item.isArrow" class="el-icon-arrow-down"></i>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
	<div class="page-header" v-else>
		<div class="container flex">
			<a href="index.html"><img src="../assets/images/logo.png" alt="" height="38"/></a>
			<div class="items flex">
				<div v-for="(item, index) in menuArr" :key="index">
					<div v-if="!item.isArrow" :class="{ 'item-menu': 1, 'item-active': tabIndex == item.id }" @click="pageSet(item)">
						<div>{{ item.name }}</div>
					</div>
					<el-popover v-else placement="bottom" width="210" trigger="hover" :visible-arrow="false" popper-class="header-pop">
						<div class="menu-box">
							<template v-if="item.id == 1">
								<div  :class="{'menu-item':1,active:currentProduct == item.id}" v-for="(item, index) in prodectArr" :key="index" @click="handleClickProdect(item)">{{ item.productName }}</div>
							</template>
							<template v-if="item.id == 4 && planArr.length != 0">
								<div  :class="{'menu-item':1,active:currentPlan == item.id}" v-for="(item, index) in planArr" :key="index" @click="handleClickPlan(item)">{{ item.schemeName }}</div>
							</template>
						</div>
						<div slot="reference">
							<div :class="{ 'item-menu': 1, 'item-active': tabIndex == item.id }" @click="pageSet(item)">
								<div>{{ item.name }}</div>
								<i style="margin-left: 4px;" v-if="item.isArrow" class="el-icon-arrow-down"></i>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["tabIndex", "noWrite"],
	data() {
		return {
			menuArr: [
				{
					name: "首页",
					path: "index",
					isArrow: false,
					isJump: false,
					id: 0,
				},
				{
					name: "产品",
					path: "product",
					isArrow: true,
					isJump: false,
					id: 1,
					children: [
						{
							name: "产品中心",
							path: "product",
						},
						{
							name: "产品中心",
							path: "product",
						},
						{
							name: "产品中心",
							path: "product",
						},
					],
				},
				{
					name: "云族",
					path: "http://www.jizhiyunzu.com",
					isJump: true,
					isArrow: false,
					id: 2,
				},

				{
					name: "方案",
					path: "plan",
					isJump: false,
					isArrow: true,
					id: 4,
				},

				{
					name: "下载",
					path: "download",
					isJump: false,
					isArrow: false,
					id: 5,
				},
				{
					name: "学习",
					path: "https://space.bilibili.com/1120539006",
					isJump: true,
					isArrow: false,
					id: 6,
				},

				{
					name: "案例",
					path: "cases",
					isJump: false,
					isArrow: false,
					id: 7,
				},
				{
					name: "新闻资讯",
					path: "news",
					isJump: false,
					isArrow: false,
					id: 8,
				},
				{
					name: "关于我们",
					path: "about",
					isArrow: false,
					isJump: false,
					id: 9,
				},
			],
			prodectArr: [],
			planArr:[],
			currentPlan:null,
			currentProduct:null,

		};
	},
	created() {
		this.currentPlan = sessionStorage.getItem('currentPlan')
		this.currentProduct = sessionStorage.getItem('currentProduct')
		this.getProduct()
		this.getPlanListData()
	},
	mounted() {
		window.scrollTo({
			top: 0,
			behavior: "smooth", // 平滑滚动
		});
	},
	methods: {
		getProduct(){
			this._get(this.API.productList+'?pageNo=1&pageSize=100').then(res=>{
				// console.log('产品列表=====',res)
				if(res.code==200){
					this.prodectArr = res.data.records
				}
			})
		},
		getPlanListData() {
			this._get(this.API.planList+'?pageNo=1&pageSize=100').then(res => {
				if(res.code == 200) {
					this.planArr = res.data.records
				}
			})
		},
		pageSet(item) {
			if (item.isJump) {
				window.open(item.path);
				return;
			}
			sessionStorage.removeItem('currentPlan')
			sessionStorage.removeItem('currentProduct')
			this.$router.push(item.path);

			if (!item.isArrow) {
				this.$router.push({ name: item.path });
				return;
			}
		},
		handleClickPlan(item) {
			sessionStorage.removeItem('currentProduct')
			sessionStorage.setItem('currentPlan',item.id)
			this.$router.push({ name: 'empty', query: { path:'plan',id:item.id } });

		},
		handleClickProdect(item) {
			sessionStorage.removeItem('currentPlan')
			sessionStorage.setItem('currentProduct',item.id)
			this.$router.push({ name: 'empty', query: { path:'product',id:item.id } });
		}
	},
};
</script>
<style lang="less" scoped>
.page-header_write {
	height: 60px;
	background-color: #fff;
	color: #222222;
	font-size: 16px;
	width: 100%;
	display: flex;
	justify-content: center;
	box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
	position: fixed;
	top: 0;
	z-index: 1000;
	.container {
		width: 1200px;
		justify-content: space-between;
		.items {
			margin-left: 55px;
			justify-content: space-between;
			.item-menu {
				padding: 0 27px;
				height: 60px;
				display: flex;
				align-items: center;
				cursor: pointer;				
				position: relative;
				&:hover {
					color: @main-color;
				}
				div{
					caret-color: transparent;
				}
			}
			.item-active {
				color: @main-color;
				&::after {
					content: "";
					position: absolute;
					transform: translateX(-50%);
					left: 50%;
					bottom: 0;
					display: block;
					width: 64px;
					height: 4px;
					background-color: @main-color;
					border-radius: 1000px;
				}
			}
		}
	}
}
.page-header {
	height: 60px;
	background-color: rgba(255, 255, 255, 0);
	color: #fff;
	font-size: 16px;
	width: 100%;
	display: flex;
	justify-content: center;
	position: fixed;
	top: 0;
	z-index: 1000;
	.container {
		width: 1200px;
		justify-content: space-between;
		.items {
			margin-left: 55px;
			justify-content: space-between;
			color: #fff;
			.item-menu {
				padding: 0 27px;
				height: 60px;
				display: flex;
				align-items: center;
				cursor: pointer;
				position: relative;
			}
			.item-active {
				&::after {
					content: "";
					position: absolute;
					transform: translateX(-50%);
					left: 50%;
					bottom: 0;
					display: block;
					width: 64px;
					height: 4px;
					background: linear-gradient(90deg, #1173f2 0%, #2bbffb 100%);
					border-radius: 1000px;
				}
			}
		}
	}
}
.menu-box {
	.menu-item {
		height: 38px;
		color: #444444;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		&:hover {
			color: @main-color;
		}
	}
	.active {
		color: @main-color;

	}
}
</style>
